import {
  O_MAP,
  SWITCH_POSITION_UPPER,
  SWITCH_POSITION_LOWER,
  SWITCH_POSITION_INDICATOR,
  SWITCH_POSITION_MIDDLE,
  BHM_DIGITAL_IN,
  BHM_DIGITAL_OUT,
  BHM_ANALOG_IN,
  BHM_FREQ_IN,
  BHM_PWM_OUT,
  BHM_MOTOR_OUT,
  DMA,
  CIRCUIT,
  CAN_MESSAGE,
  DISABLED,
  stringMaxVal,
} from 'utils/constants'

export const getKeyByValue = (object, value) =>
  Object.keys(object).find(
    (key) => object[key][0] === value[0] && object[key][1] === value[1]
  )

export const bitString = {
  0: ['1', '1'],
  1: ['1', '2'],
  2: ['1', '3'],
  3: ['1', '4'],
  4: ['1', '5'],
  5: ['1', '6'],
  6: ['1', '7'],
  7: ['1', '8'],

  8: ['2', '1'],
  9: ['2', '2'],
  10: ['2', '3'],
  11: ['2', '4'],
  12: ['2', '5'],
  13: ['2', '6'],
  14: ['2', '7'],
  15: ['2', '8'],

  16: ['3', '1'],
  17: ['3', '2'],
  18: ['3', '3'],
  19: ['3', '4'],
  20: ['3', '5'],
  21: ['3', '6'],
  22: ['3', '7'],
  23: ['3', '8'],

  24: ['4', '1'],
  25: ['4', '2'],
  26: ['4', '3'],
  27: ['4', '4'],
  28: ['4', '5'],
  29: ['4', '6'],
  30: ['4', '7'],
  31: ['4', '8'],

  32: ['5', '1'],
  33: ['5', '2'],
  34: ['5', '3'],
  35: ['5', '4'],
  36: ['5', '5'],
  37: ['5', '6'],
  38: ['5', '7'],
  39: ['5', '8'],

  40: ['6', '1'],
  41: ['6', '2'],
  42: ['6', '3'],
  43: ['6', '4'],
  44: ['6', '5'],
  45: ['6', '6'],
  46: ['6', '7'],
  47: ['6', '8'],

  48: ['7', '1'],
  49: ['7', '2'],
  50: ['7', '3'],
  51: ['7', '4'],
  52: ['7', '5'],
  53: ['7', '6'],
  54: ['7', '7'],
  55: ['7', '8'],

  56: ['8', '1'],
  57: ['8', '2'],
  58: ['8', '3'],
  59: ['8', '4'],
  60: ['8', '5'],
  61: ['8', '6'],
  62: ['8', '7'],
  63: ['8', '8'],
}

export function getNumBits(apiVal) {
  switch (apiVal) {
    case '0':
      return '1'
    case '1':
      return '2'
    case '2':
      return '3'
    case '3':
      return '4'
    case '4':
      return '8'
    case '5':
      return '16'
    case '6':
      return '32'
    case '7':
      return 'N/A'
    default:
      return ''
  }
}

export function getBitsApiRepresentation(semanticVal) {
  switch (semanticVal) {
    case '1':
      return '0'
    case '2':
      return '1'
    case '3':
      return '2'
    case '4':
      return '3'
    case '8':
      return '4'
    case '16':
      return '5'
    case '32':
      return '6'
    default:
      return '7'
  }
}

export const digitalOutputsConnectorAndPin = {
  24: ['C5C', 'H'],
  25: ['C3C', 'F'],
  26: ['C1C', 'L'],
  27: ['C5C', 'B'],
  28: ['C3C', 'H'],
  29: ['C4C', 'B'],
  30: ['C3C', 'G'],
  31: ['C4C', 'B Off'],
  32: ['C1C', 'F'],
  33: ['C1C', 'F Off'],
  34: ['C5C', 'D'],
  35: ['C5C', 'D Off'],
  36: ['C1C', 'R'],
  37: ['C1C', 'R Off'],
  38: ['C1C', 'K'],
  39: ['C1C', 'K Off'],
  40: ['C3C', 'E'],
  41: ['C3C', 'E HW Override'],
  42: ['C5C', 'F Off'],
  43: ['C2C', 'M'],
  44: ['C5C', 'A9'],
  45: ['C5C', 'A Off'],
  48: ['C6C', 'B4'],
  49: ['C6C', 'B8'],
  50: ['C6C', 'A5'],
  51: ['C6C', 'A9'],
  52: ['C6C', 'B10'],
  53: ['C5C', 'G'],
  54: ['C4C', 'E'],
  55: ['C4C', 'M'],
  56: ['C5C', 'F'],
  57: ['C5C', 'A'],
}

export const digitalInputsConnectorAndPin = {
  0: ['C5C', 'B2'],
  1: ['C5C', 'A1'],
  2: ['C1C', 'C'],
  3: ['C4C', 'D'],
  4: ['C5C', 'B11'],
  5: ['C3C', 'C'],
  6: ['C4C', 'L'],
  7: ['C4C', 'A'],
  8: ['C2C', 'G'],
  9: ['C5C', 'B10'],
  10: ['C5C', 'B9'],
  11: ['C5C', 'A5'],
  12: ['C5C', 'B1'],
  13: ['C2C', 'P'],
  14: ['C1C', 'B'],
  15: ['C5C', 'B8'],
  16: ['C5C', 'A6'],
  17: ['C5C', 'B7'],
  18: ['C5C', 'B6'],
  19: ['C5C', 'A7'],
  20: ['C5C', 'B5'],
  21: ['C1C', 'M'],
  22: ['C5C', 'A3'],
  23: ['C5C', 'B3'],
}

// BHM_ANALOG_IN and BHM_FREQ_IN share these analog mappings
export const analogInputsConnectorAndPin = {
  5: ['C1C', 'A'],
  6: ['C6C', 'A2'],
  7: ['C6C', 'A8'],
  8: ['C6C', 'A4'],
  9: ['C6C', 'B11'],
  12: ['C1C', 'N'],
  14: ['C3C', 'D'],
  16: ['C6C', 'B2'],
  17: ['C6C', 'B6'],
  18: ['C6C', 'B5'],
  19: ['C6C', 'A10'],
  24: ['C4C', 'G'],
  26: ['C6C', 'A3'],
  27: ['C6C', 'B7'],
  28: ['C6C', 'A6'],
  29: ['C6C', 'A11'],
  34: ['C4C', 'K'],
  36: ['C6C', 'B1'],
  37: ['C6C', 'A7'],
  38: ['C6C', 'B3'],
  42: ['C1C', 'J'],
}

export const extendedAnalogInputsConnectorAndPin = {
  0: ['C4C', 'B'],
  1: ['C3C', 'H'],
  2: ['C3C', 'F'],
  3: ['C5C', 'H'],
  4: ['C5C', 'H'],
  10: ['C4C', 'M'],
  11: ['C5C', 'A'],
  13: ['C2C', 'M'],
  15: ['C3C', 'E'],
  20: ['C5C', 'B'],
  21: ['C4C', 'E'],
  22: ['C1C', 'R'],
  23: ['C5C', 'A9'],
  25: ['C5C', 'D'],
  30: ['C5C', 'G'],
  31: ['C5C', 'G'],
  32: ['C5C', 'F'],
  33: ['C1C', 'L'],
  35: ['C3C', 'E'],
  39: ['C4C', 'E'],
  40: ['C4C', 'M'],
  41: ['C5C', 'F'],
  43: ['C1C', 'F'],
  44: ['C3C', 'G'],
  45: ['C1C', 'K'],
}

export const pwmConnectorAndPin = {
  0: ['C5C', 'H'],
  2: ['C1C', 'R'],
  3: ['C5C', 'B'],
}

export function connectorAndPin(type, value) {
  switch (type) {
    case BHM_DIGITAL_IN:
      return digitalInputsConnectorAndPin[value]
        ? digitalInputsConnectorAndPin[value]
        : ['N/A', 'N/A']
    case BHM_MOTOR_OUT:
    case BHM_DIGITAL_OUT:
      return digitalOutputsConnectorAndPin[value]
        ? digitalOutputsConnectorAndPin[value]
        : ['N/A', 'N/A']
    case BHM_ANALOG_IN: {
      const allAnalogInputs = Object.assign(
        analogInputsConnectorAndPin,
        extendedAnalogInputsConnectorAndPin
      )
      return allAnalogInputs[value] ? allAnalogInputs[value] : ['N/A', 'N/A']
    }
    case BHM_FREQ_IN:
      return analogInputsConnectorAndPin[value]
        ? analogInputsConnectorAndPin[value]
        : ['N/A', 'N/A']
    case BHM_PWM_OUT:
      return pwmConnectorAndPin[value]
        ? pwmConnectorAndPin[value]
        : ['N/A', 'N/A']
    default:
      return ['N/A', 'N/A']
  }
}

export function connectorAndPinApiRepresentation(type, connector, pin) {
  const value = [connector, pin]

  switch (type) {
    case BHM_DIGITAL_IN:
      return getKeyByValue(digitalInputsConnectorAndPin, value)
    case BHM_MOTOR_OUT:
    case BHM_DIGITAL_OUT:
      return getKeyByValue(digitalOutputsConnectorAndPin, value)
    case BHM_ANALOG_IN: {
      const allAnalogInputs = Object.assign(
        analogInputsConnectorAndPin,
        extendedAnalogInputsConnectorAndPin
      )
      return getKeyByValue(allAnalogInputs, value)
    }
    case BHM_FREQ_IN:
      return getKeyByValue(analogInputsConnectorAndPin, value)
    case BHM_PWM_OUT:
      return getKeyByValue(pwmConnectorAndPin, value)
    default:
      return ['N/A', 'N/A']
  }
}

export function validConnectors(type) {
  switch (type) {
    case BHM_DIGITAL_IN:
      return [
        ...new Set(
          Object.values(digitalInputsConnectorAndPin).map((value) => value[0])
        ),
      ].sort()
    case BHM_MOTOR_OUT:
    case BHM_DIGITAL_OUT:
      return [
        ...new Set(
          Object.values(digitalOutputsConnectorAndPin).map((value) => value[0])
        ),
      ].sort()
    case BHM_ANALOG_IN: {
      const allAnalogInputs = Object.assign(
        analogInputsConnectorAndPin,
        extendedAnalogInputsConnectorAndPin
      )
      return [
        ...new Set(Object.values(allAnalogInputs).map((value) => value[0])),
      ].sort()
    }
    case BHM_FREQ_IN:
      return [
        ...new Set(
          Object.values(analogInputsConnectorAndPin).map((value) => value[0])
        ),
      ].sort()
    case BHM_PWM_OUT:
      return [
        ...new Set(Object.values(pwmConnectorAndPin).map((value) => value[0])),
      ].sort()
    default:
      return []
  }
}

export function validPins(type, connector) {
  const allAnalogInputs = Object.assign(
    analogInputsConnectorAndPin,
    extendedAnalogInputsConnectorAndPin
  )

  switch (true) {
    case type === BHM_DIGITAL_IN && connector === 'C1C':
      return Object.values(digitalInputsConnectorAndPin)
        .filter((value) => value[0] === 'C1C')
        .map((v) => v[1])
        .sort()
    case type === BHM_DIGITAL_IN && connector === 'C2C':
      return Object.values(digitalInputsConnectorAndPin)
        .filter((value) => value[0] === 'C2C')
        .map((v) => v[1])
        .sort()
    case type === BHM_DIGITAL_IN && connector === 'C3C':
      return Object.values(digitalInputsConnectorAndPin)
        .filter((value) => value[0] === 'C3C')
        .map((v) => v[1])
        .sort()
    case type === BHM_DIGITAL_IN && connector === 'C4C':
      return Object.values(digitalInputsConnectorAndPin)
        .filter((value) => value[0] === 'C4C')
        .map((v) => v[1])
        .sort()
    case type === BHM_DIGITAL_IN && connector === 'C5C':
      return Object.values(digitalInputsConnectorAndPin)
        .filter((value) => value[0] === 'C5C')
        .map((v) => v[1])
        .sort()

    case type === BHM_DIGITAL_OUT && connector === 'C1C':
    case type === BHM_MOTOR_OUT && connector === 'C1C':
      return Object.values(digitalOutputsConnectorAndPin)
        .filter((value) => value[0] === 'C1C')
        .map((v) => v[1])
        .sort()
    case type === BHM_DIGITAL_OUT && connector === 'C2C':
    case type === BHM_MOTOR_OUT && connector === 'C2C':
      return Object.values(digitalOutputsConnectorAndPin)
        .filter((value) => value[0] === 'C2C')
        .map((v) => v[1])
        .sort()
    case type === BHM_DIGITAL_OUT && connector === 'C3C':
    case type === BHM_MOTOR_OUT && connector === 'C3C':
      return Object.values(digitalOutputsConnectorAndPin)
        .filter((value) => value[0] === 'C3C')
        .map((v) => v[1])
        .sort()
    case type === BHM_DIGITAL_OUT && connector === 'C4C':
    case type === BHM_MOTOR_OUT && connector === 'C4C':
      return Object.values(digitalOutputsConnectorAndPin)
        .filter((value) => value[0] === 'C4C')
        .map((v) => v[1])
        .sort()
    case type === BHM_DIGITAL_OUT && connector === 'C5C':
    case type === BHM_MOTOR_OUT && connector === 'C5C':
      return Object.values(digitalOutputsConnectorAndPin)
        .filter((value) => value[0] === 'C5C')
        .map((v) => v[1])
        .sort()
    case type === BHM_DIGITAL_OUT && connector === 'C6C':
    case type === BHM_MOTOR_OUT && connector === 'C6C':
      return Object.values(digitalOutputsConnectorAndPin)
        .filter((value) => value[0] === 'C6C')
        .map((v) => v[1])
        .sort()

    case type === BHM_ANALOG_IN && connector === 'C1C':
      return Object.values(allAnalogInputs)
        .filter((value) => value[0] === 'C1C')
        .map((v) => v[1])
        .sort()
    case type === BHM_ANALOG_IN && connector === 'C2C':
      return Object.values(allAnalogInputs)
        .filter((value) => value[0] === 'C2C')
        .map((v) => v[1])
        .sort()
    case type === BHM_ANALOG_IN && connector === 'C3C':
      return Object.values(allAnalogInputs)
        .filter((value) => value[0] === 'C3C')
        .map((v) => v[1])
        .sort()
    case type === BHM_ANALOG_IN && connector === 'C4C':
      return Object.values(allAnalogInputs)
        .filter((value) => value[0] === 'C4C')
        .map((v) => v[1])
        .sort()
    case type === BHM_ANALOG_IN && connector === 'C5C':
      return Object.values(allAnalogInputs)
        .filter((value) => value[0] === 'C5C')
        .map((v) => v[1])
        .sort()
    case type === BHM_ANALOG_IN && connector === 'C6C':
      return Object.values(allAnalogInputs)
        .filter((value) => value[0] === 'C6C')
        .map((v) => v[1])
        .sort()

    case type === BHM_FREQ_IN && connector === 'C1C':
      return Object.values(analogInputsConnectorAndPin)
        .filter((value) => value[0] === 'C1C')
        .map((v) => v[1])
        .sort()
    case type === BHM_FREQ_IN && connector === 'C3C':
      return Object.values(analogInputsConnectorAndPin)
        .filter((value) => value[0] === 'C3C')
        .map((v) => v[1])
        .sort()
    case type === BHM_FREQ_IN && connector === 'C4C':
      return Object.values(analogInputsConnectorAndPin)
        .filter((value) => value[0] === 'C4C')
        .map((v) => v[1])
        .sort()
    case type === BHM_FREQ_IN && connector === 'C6C':
      return Object.values(analogInputsConnectorAndPin)
        .filter((value) => value[0] === 'C6C')
        .map((v) => v[1])
        .sort()

    case type === BHM_PWM_OUT && connector === 'C1C':
      return Object.values(pwmConnectorAndPin)
        .filter((value) => value[0] === 'C1C')
        .map((v) => v[1])
        .sort()
    case type === BHM_PWM_OUT && connector === 'C5C':
      return Object.values(pwmConnectorAndPin)
        .filter((value) => value[0] === 'C5C')
        .map((v) => v[1])
        .sort()

    default:
      return []
  }
}

export function getMapTypeRepresentation(apiVal) {
  switch (apiVal) {
    case '1':
      return BHM_DIGITAL_IN
    case '2':
      return BHM_DIGITAL_OUT
    case '3':
      return BHM_ANALOG_IN
    case '4':
      return BHM_FREQ_IN
    case '5':
      return BHM_PWM_OUT
    case '6':
      return BHM_MOTOR_OUT
    case '7':
    case 'M':
      return CAN_MESSAGE
    case '8':
      return DMA
    case '9':
    case 'SA':
      return SWITCH_POSITION_UPPER
    case '10':
    case 'SB':
      return SWITCH_POSITION_LOWER
    case '11':
    case 'SI':
      return SWITCH_POSITION_INDICATOR
    case '12':
      return SWITCH_POSITION_MIDDLE
    case '0':
    case '63':
    case 'D':
      return DISABLED
    case 'C':
      return CIRCUIT
    default:
      return 'Unrecognized'
  }
}

export function getMapTypeApiRepresentation(semanticVal, spType) {
  switch (semanticVal) {
    case BHM_DIGITAL_IN:
      return '1'
    case BHM_DIGITAL_OUT:
      return '2'
    case BHM_ANALOG_IN:
      return '3'
    case BHM_FREQ_IN:
      return '4'
    case BHM_PWM_OUT:
      return '5'
    case BHM_MOTOR_OUT:
      return '6'
    case CAN_MESSAGE:
      return spType === O_MAP ? 'M' : '7'
    case DMA:
      return '8'
    case SWITCH_POSITION_UPPER:
      return spType === O_MAP ? 'SA' : '9'
    case SWITCH_POSITION_LOWER:
      return spType === O_MAP ? 'SB' : '10'
    case SWITCH_POSITION_INDICATOR:
      return spType === O_MAP ? 'SI' : '11'
    case SWITCH_POSITION_MIDDLE:
      return '12'
    case CIRCUIT:
      return 'C'
    case DISABLED:
      return spType === O_MAP ? 'D' : '0'
    default:
      return ''
  }
}

export const canSlots = {
  0: 'PGN 61184, Transmit, CHM PROPRIETARY A - 0X15',
  1: 'PGN 61184, Receive, CHM PROPRIETARY A - 0X16',
  2: 'PGN 61184, Receive, CHM PROPRIETARY A - 0X20',
  3: 'PGN 61184, Receive, CHM PROPRIETARY A - 0X21',
  4: 'PGN 61184, Receive, CHM PROPRIETARY A - 0X22',
  5: 'PGN 61184, Receive, CHM PROPRIETARY A - 0X23',
  6: 'PGN 61184, Receive, ICU PROPRIETARY A - 0X01',
  7: 'PGN 61184, Transmit, ICU PROPRIETARY A - 0X02',
  8: 'PGN 65265, Transmit, CRUISE CONTROL SPEED - TX',
  9: 'PGN 65265, Receive, CRUISE CONTROL SPEED - RX',
  10: 'PGN 61445, Receive, ELEC TRANS CONTROLLER 2',
  11: 'PGN 65279, Transmit, WATER IN FUEL INDICATOR',
  12: 'PGN 65276, Transmit, DASH DISPLAY',
  13: 'PGN 61441, Transmit, ELEC BRAKE CONTROLLER 1',
  14: 'PGN 65274, Transmit, BRAKES',
  15: 'PGN 61444, Receive, EEC1',
  16: 'PGN 65098, Receive, ETC7',
  17: 'PGN 61184, Receive, CHM PROPRIETARY A - 0X17',
  18: 'PGN 65248, Receive, VEHICLE DISTANCE',
  19: '',
  20: '',
  21: '',
  22: '',
  23: '',
  24: '',
  25: '',
  26: '',
  27: '',
  28: '',
  29: '',
  30: '',
  31: '',
  32: '',
  33: '',
  34: '',
  35: '',
  36: '',
  37: '',
  38: '',
  39: '',
  40: '',
  41: '',
  42: '',
  43: '',
  44: '',
  45: '',
  46: '',
  47: '',
  48: '',
  49: '',
}

// Utility function returns value of lowest connector / pin value for map type for display after new map type selection
const getConnectorAndPin = (value) => {
  switch (value) {
    case BHM_DIGITAL_IN:
      return '14'
    case BHM_MOTOR_OUT:
    case BHM_DIGITAL_OUT:
      return '26'
    case BHM_PWM_OUT:
      return '2'
    case BHM_ANALOG_IN:
    case BHM_FREQ_IN:
    default:
      return '5'
  }
}

// Utility function, returns array of default fieldname/value pairs specific to map type
export const getDefaultValues = (type, isOMap) => {
  const oMapSwitchDefaults = [
    ['logical_slot', '0'],
    ['physical_slot', '17'],
  ]
  switch (true) {
    // 17 is the lowest value in the switch list
    case isOMap &&
      [
        SWITCH_POSITION_UPPER,
        SWITCH_POSITION_INDICATOR,
        SWITCH_POSITION_MIDDLE,
      ].includes(type):
      return oMapSwitchDefaults
    case isOMap && type === SWITCH_POSITION_LOWER:
      return [...oMapSwitchDefaults, ['priority', stringMaxVal]]
    case !isOMap &&
      [
        SWITCH_POSITION_UPPER,
        SWITCH_POSITION_LOWER,
        SWITCH_POSITION_INDICATOR,
        SWITCH_POSITION_MIDDLE,
      ].includes(type):
      return [
        ['rowid', '0'],
        ['data_value', '17'],
      ]
    case [
      BHM_DIGITAL_IN,
      BHM_DIGITAL_OUT,
      BHM_ANALOG_IN,
      BHM_FREQ_IN,
      BHM_PWM_OUT,
      BHM_MOTOR_OUT,
    ].includes(type): {
      // Set connector and pin values to lowest alpha values for type
      const dataValue = getConnectorAndPin(type)
      return [
        ['rowid', '0'],
        [
          'priority',
          [BHM_DIGITAL_IN, BHM_ANALOG_IN, BHM_FREQ_IN].includes(type)
            ? stringMaxVal
            : '0',
        ],
        ['data_value', dataValue],
      ]
    }
    case type === DMA:
      return [
        ['rowid', '0'],
        ['length', '0'],
        ['data_value', '0'],
      ]
    case type === CAN_MESSAGE:
      return [
        [isOMap ? 'logical_slot' : 'rowid', '0'],
        ['priority', '0'],
        ['length', '0'],
        ['offset', '0'],
        [isOMap ? 'physical_slot' : 'data_value', '0'],
      ]
    case type === CIRCUIT:
      return [
        ['logical_slot', '0'],
        ['priority', stringMaxVal],
        ['physical_slot', 'BBAC'],
        ['inverted', '0'],
      ]
    default:
      return []
  }
}
